"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = void 0;
const metadata_1 = require("../metadata");
exports.networks = {
    ethereum: {
        name: metadata_1.chains.ethereum.name,
        image: metadata_1.chains.ethereum.image,
        networkId: 5,
        publicRpcUrl: 'https://goerli.infura.io/v3/84842078b09946638c03157f83405213',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://goerli.etherscan.io'],
        waitConfirmations: 1
    },
    polygon: {
        name: metadata_1.chains.polygon.name,
        image: metadata_1.chains.polygon.image,
        networkId: 80001,
        publicRpcUrl: 'https://rpc.ankr.com/polygon_mumbai',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://mumbai.polygonscan.com'],
        nativeBridgeUrl: 'https://wallet.matic.network/bridge/',
        waitConfirmations: 1
    },
    optimism: {
        name: metadata_1.chains.optimism.name,
        image: metadata_1.chains.optimism.image,
        networkId: 420,
        publicRpcUrl: 'https://rpc.ankr.com/optimism_testnet',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://goerli-optimism.etherscan.io/'],
        nativeBridgeUrl: 'https://app.optimism.io/bridge',
        waitConfirmations: 1
    },
    arbitrum: {
        name: metadata_1.chains.arbitrum.name,
        image: metadata_1.chains.arbitrum.image,
        networkId: 421613,
        publicRpcUrl: 'https://goerli-rollup.arbitrum.io/rpc',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://goerli-rollup-explorer.arbitrum.io'],
        nativeBridgeUrl: 'https://bridge.arbitrum.io/',
        waitConfirmations: 1
    },
    zksync: {
        name: metadata_1.chains.zksync.name,
        image: metadata_1.chains.zksync.image,
        networkId: 280,
        publicRpcUrl: 'https://zksync2-testnet.zksync.dev',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://goerli.explorer.zksync.io', 'https://zksync2-testnet.zkscan.io'],
        nativeBridgeUrl: '',
        waitConfirmations: 1
    },
    consensyszk: {
        name: metadata_1.chains.consensyszk.name,
        image: metadata_1.chains.consensyszk.image,
        networkId: 59140,
        publicRpcUrl: 'https://consensys-zkevm-goerli-prealpha.infura.io/v3/9d6a30e37af5474a98d9acf6470473de',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://explorer.goerli.zkevm.consensys.net'],
        nativeBridgeUrl: 'https://bridge.goerli.zkevm.consensys.net',
        waitConfirmations: 1
    }
};
